import { Navigate, useLocation } from "react-router-dom";
import { AuthData, useAuth } from "../contexts/Auth";

function RequireAdminRole({ children }: { children: React.ReactNode }) {
  const { authData } = useAuth() as { authData: AuthData };
  let location = useLocation();

  if (authData && authData.role !== 1) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default RequireAdminRole;
